import { render, staticRenderFns } from "./task-comment-form.vue?vue&type=template&id=1f796722&"
import script from "./task-comment-form.vue?vue&type=script&lang=js&"
export * from "./task-comment-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f796722')) {
      api.createRecord('1f796722', component.options)
    } else {
      api.reload('1f796722', component.options)
    }
    module.hot.accept("./task-comment-form.vue?vue&type=template&id=1f796722&", function () {
      api.rerender('1f796722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-comment-form.vue"
export default component.exports